import { organisationConstants } from '../../../_constants';

const initialState = { getCompetencyManageMetricLoading: true, data: '', error: false };

export function ManageCompetencyList(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_COMPETENCY:
            return {
                getCompetencyManageMetricLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECIEVE_COMPETENCY:
            return {
                getCompetencyManageMetricLoading: false,
                data: action.manageCompetencyList,
                error: false
            };
        case organisationConstants.ERROR_COMPETENCY:
            return {
                getCompetencyManageMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/getCompetency.reducer.js